import { render } from "./FullresAnalytics.vue?vue&type=template&id=bc4b9efc"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__